/**
 * Container and truck types belong to the company that made them and are shared across its holding:
 * every company of the holding sees and uses them; changing one needs a write right on its company.
 */
export type Id = bigint | number | string | null | undefined;

type OwnedType = {
  ownerOrganizationId?: Id;
  ownerOrganization?: { name?: string } | null;
};

export const isOwnType = (type: OwnedType, companyId: Id): boolean =>
  companyId != null && String(type.ownerOrganizationId) === String(companyId);

/** The owner's name when another company of the holding made the type, else undefined. */
export const foreignOwnerName = (type: OwnedType, companyId: Id): string | undefined =>
  isOwnType(type, companyId) ? undefined : type.ownerOrganization?.name || undefined;
